export default {
  promotions: (state: any) => state.promotions,
  promotion: (state: any) => state.promotion,
  promotionTerms: (state: any) => state.promotionTerms,
  materials: (state: any) => state.promotion.materials,
  promoCodes: (state: any) => state.promoCodes.data,
  // errors: (state: any) => state.errors,
}
